export default "/_next/static/src/lib/assets/rive/85d019adc89563f0e30bad5b38dd19ea.riv";